<template>
    <nio-modal
        name="campaign"
        size="sm"
        :title="modalTitle"
        ref="modal"
        @closed="onClosed"
        @open="onOpen"
        @opened="onOpened"
    >
        <form class="space-y-6" @submit.prevent="onSave">
            <nio-input-group :label="$t('campaigns.campaignModal.name')">
                <nio-input :required="true" ref="name" v-model="campaign.name" />
            </nio-input-group>

            <error-message />
        </form>

        <template #footer>
            <nio-button :disabled="saving" @click="close">
                {{ $t('global.general.cancel') }}
            </nio-button>
            <nio-button
                color="blue"
                :disabled="!valid"
                :loading="saving"
                @click="onSave"
            >
                {{ saveButtonText }}
            </nio-button>
        </template>
    </nio-modal>
</template>

<script>
    import { mapActions } from 'vuex';
    import Campaign from '@/entities/Campaign.js';

    export default {
        data() {
            return {
                saving: false,
                campaign: new Campaign(),
                redirectTo: null,
            };
        },

        computed: {
            isEdit() {
                return this.campaign.isExisting();
            },

            modalTitle() {
                return this.isEdit ? this.$t('campaigns.campaignModal.editTitle') : this.$t('campaigns.campaignModal.addTitle');
            },

            saveButtonText() {
                return this.isEdit ? this.$t('global.general.save') : this.$t('global.general.create');
            },

            valid() {
                return this.campaign.isValid();
            },
        },

        methods: {
            ...mapActions('campaign', [
                'createCampaign',
                'updateCampaign',
            ]),

            async onSave() {
                if (!this.valid) {
                    return;
                }

                try {
                    this.saving = true;

                    if (this.isEdit) {
                        await this.onUpdate();
                    } else {
                        await this.onCreate();
                    }

                    this.close();
                } catch (error) {
                    this.$notify.show({
                        type: 'error',
                        message: this.$t('campaigns.campaignModal.errors.saving'),
                    });

                    throw error;
                } finally {
                    this.saving = false;
                }
            },

            async onCreate() {
                const newCampaign = await this.createCampaign(this.campaign);

                this.$notify.show({
                    type: 'success',
                    message: this.$t('campaigns.campaignModal.successes.created'),
                });

                this.redirectTo = {
                    name: 'campaign',
                    params: {
                        id: newCampaign.id,
                    },
                };
            },

            async onUpdate() {
                await this.updateCampaign(this.campaign);

                this.$notify.show({
                    type: 'success',
                    message: this.$t('campaigns.campaignModal.successes.updated'),
                });
            },

            onOpen({ campaign } = {}) {
                this.campaign.fill(campaign);
            },

            onOpened() {
                this.$refs.name.focus();
            },

            onClosed() {
                this.$reset({ redirectTo: this.redirectTo });
            },

            close() {
                this.$refs.modal.close();
            },
        },
    };
</script>
